import axios from './config/axios'

export const getSettings = () => axios.get('/settings')

export const updateSetting = (data) => axios.put('/settings', data)
